module.exports = __webpack_public_path__ + "img/Z71_02.4b52523b.jpg";